import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import * as React from 'react'

import BlueConicContent from '../../BlueConicContent'
import RecommendedProducts from '../../catalog/RecommendedProducts'
import ErrorBoundary from '../../ErrorBoundary'
import { useSelector } from '../../types'

interface Props {
    className?: string
}

const CartPageCrosssell = ({ className }: Props) => {
    const cart = useSelector((state) => state.cart)

    // Check for cart items
    if (
        !cart.details ||
        !cart.details.items ||
        cart.details.items.length === 0
    ) {
        return null
    }

    // Get id from most expensive product in cart to be used in recommended products
    const productId = [...cart.details.items].sort(
        (a, b) => b.price - a.price,
    )[0].product_id

    return (
        <ErrorBoundary fallback={<React.Fragment />}>
            <BlueConicContent blueConicPosition="cartSlider">
                <RecommendedProducts
                    recommendationsType="crosssell"
                    header={t({
                        id: 'cart.cartPage.upSellTitle',
                        message: `This goes well with`,
                    })}
                    productId={productId}
                    className={className}
                    itemListSlot="cartSlider"
                />
            </BlueConicContent>
        </ErrorBoundary>
    )
}

export default CartPageCrosssell
